import React from 'react'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useTheme, makeStyles } from '@material-ui/core'
import { styles } from './accordionSection.styles'

export const AccordionSection = ({ children, sectionTitle, ...props }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const index = 1
  return (
    <Accordion
      {...props}
      className={classes.collapsibleSectionHeader}
      elevation={0}
      square={false}
      key={index}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="index">
        <Typography variant="subtitle1" className={classes.sectionTitle} color="primary">
          {sectionTitle}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}
